













import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class Checkbox extends Vue {
  name: "Checkbox";

  @Prop({ required: true })
  public id!: string;

  @Prop({ default: "" })
  public value!: boolean;

  @Prop({ required: true })
  public labelName!: string;

  get isChecked() {
    return this.value;
  }
  set isChecked(value) {
    this.$emit("input-checkbox", value);
  }
}
